import { useQuery } from '@tanstack/react-query';
import { QueryConfig, ExtractFnReturnType } from '../../../../lib/react-query';
import i18n from '../../../../i18n';
import { getOrganizationalStructureOptions, getOrganizationalStructureOptionsByUser } from '../../organizationalStructures/api/organizationalStructureApi';

type QueryFnType = typeof getOrganizationalStructureOptions;

type UseOrganizationalStructuresSelect = { 
  config?: QueryConfig<QueryFnType>;
};

export const useOrganizationalStructuresSelect = ({ config = {} }: UseOrganizationalStructuresSelect) => {
    return useQuery<ExtractFnReturnType<QueryFnType>>({
        ...config,
        queryKey: ['useOrganizationalStructuresSelect', i18n.language],
        queryFn: () => getOrganizationalStructureOptions(),
        refetchOnMount: false,
        refetchOnWindowFocus: false,
    });
};

type QueryFnTypeByUser = typeof getOrganizationalStructureOptionsByUser;

type UseOrganizationalStructuresSelectByUser = { 
    config?: QueryConfig<QueryFnType>;
};

export const useOrganizationalStructuresSelectByUser = ({ config = {} }: UseOrganizationalStructuresSelectByUser) => {
    return useQuery<ExtractFnReturnType<QueryFnTypeByUser>>({
        ...config,
        queryKey: ['useOrganizationalStructuresSelectByUser', i18n.language],
        queryFn: () => getOrganizationalStructureOptionsByUser(),
        refetchOnMount: true,
        refetchOnWindowFocus: false,
    });
};